module.exports = __webpack_public_path__ + "static/media/Jigna-Mehta.243fd91a.png";